import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import _ from 'lodash';
import { useUpdateSelectedOptionsMutation } from '~/types/types';
import { trackEsgSave } from '~/functions/esgSavePending';
export default defineComponent({
  inheritAttrs: false,
  props: {
    userInput: {
      type: Object,
      default: function _default() {}
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props) {
    var _useUpdateSelectedOpt = useUpdateSelectedOptionsMutation(),
      updateSelectedOptions = _useUpdateSelectedOpt.mutate,
      onDone = _useUpdateSelectedOpt.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    var value = computed(function () {
      var selected = props.userInput && Array.isArray(props.userInput.selectedOptions) ? props.userInput.selectedOptions : [];
      var values = selected.map(function (e) {
        return e.id;
      });
      return shouldAllowMultiple.value ? values : values[0];
    });
    var shouldAllowMultiple = computed(function () {
      // Allow multiple if either:
      // 1. isMultiple is true
      // 2. isMultiple is false BUT we have multiple values already selected
      return props.isMultiple || !props.isMultiple && props.userInput && Array.isArray(props.userInput.selectedOptions) && props.userInput.selectedOptions.length > 1;
    });
    var valueChange = function valueChange(value) {
      var values;
      if (_.isArray(value)) {
        values = value.filter(function (e) {
          return e !== null && e !== undefined;
        });
        // If shouldAllowMultiple is false and we're not dealing with existing multiple selections,
        // only keep the most recent selection
        if (!shouldAllowMultiple.value && values.length > 1) {
          values = [values[values.length - 1]];
        }
      } else if (value !== null && value !== undefined) {
        values = [value];
      } else {
        values = [];
      }
      trackEsgSave(Promise.resolve(updateSelectedOptions({
        userInputId: props.userInput.id,
        values: values
      })));
    };
    return {
      updateSelectedOptions: updateSelectedOptions,
      value: value,
      valueChange: valueChange,
      shouldAllowMultiple: shouldAllowMultiple
    };
  }
});